var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: [
        _vm.$style["mds-search-field"],
        _vm.classObject,
        _vm.sizeClass,
        _vm.variationClass,
      ],
      attrs: {
        "data-mds-version": _vm.version,
        role: "search",
        tabindex: _vm.tabIndex,
        "aria-labelledby": _vm.isSelection ? _vm.descriptionId : null,
      },
    },
    [
      _vm.isSelection
        ? [
            _c(
              "div",
              {
                class: _vm.$style["mds-search-field__description"],
                attrs: { id: _vm.descriptionId, "aria-live": "polite" },
              },
              [
                _vm._v(
                  "\n            " + _vm._s(_vm.descriptionInfo) + "\n        "
                ),
              ]
            ),
            _vm._v(" "),
            _vm._l(_vm.items, function (item) {
              return _c(
                "mds-tag",
                _vm._b(
                  {
                    key: item.tagId,
                    attrs: {
                      id: item.tagId,
                      text: item.text,
                      "on-light": !_vm.onDark,
                      "on-dark": _vm.onDark,
                      size: _vm.tagSize,
                    },
                    on: {
                      "mds-tag-removed": function ($event) {
                        !_vm.disabled ? _vm.handleRemoveClick(item) : null
                      },
                    },
                  },
                  "mds-tag",
                  _vm.removableTagAttributes,
                  false
                )
              )
            }),
          ]
        : _vm._e(),
      _vm._v(" "),
      _c(
        "input",
        _vm._g(
          _vm._b(
            {
              ref: "input",
              class: _vm.$style["mds-search-field__input"],
              attrs: {
                type: "text",
                disabled: _vm.disabled,
                "aria-label": _vm.label,
                placeholder: _vm.placeholder,
              },
              domProps: { value: _vm.value },
              on: {
                focus: _vm.setFocus,
                blur: _vm.removeFocus,
                keydown: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "delete", [8, 46], $event.key, [
                      "Backspace",
                      "Delete",
                      "Del",
                    ])
                  )
                    return null
                  return _vm.handleRemoveKeyboard.apply(null, arguments)
                },
              },
            },
            "input",
            _vm.$attrs,
            false
          ),
          _vm.inputListeners
        )
      ),
      _vm._v(" "),
      _c("mds-icon", {
        class: _vm.$style["mds-search-field__search-icon"],
        attrs: { name: "search", size: _vm.iconSize },
      }),
      _vm._v(" "),
      _c("mds-button", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.showRemoveButton,
            expression: "showRemoveButton",
          },
        ],
        class: _vm.$style["mds-search-field__clear-button"],
        attrs: {
          type: "button",
          variation: "icon-only",
          size: _vm.iconSize,
          icon: "remove",
          onDark: _vm.onDark,
          text: _vm.clearIconAriaLabel,
          disabled: _vm.disableButton,
        },
        on: {
          click: function ($event) {
            return _vm.clearSearchField($event)
          },
        },
      }),
      _vm._v(" "),
      _c("span", {
        class: _vm.$style["mds-search-field__input-focus-outline"],
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }